import { Pipe, PipeTransform } from "@angular/core";
import { CreditPurchaseOption } from "../stripe/stripe-product";

@Pipe({
	name: "optionToValue",
	standalone: true
})
export class OptionToValuePipe implements PipeTransform {
	transform(product: CreditPurchaseOption): string {
		switch(product)
		{
		case CreditPurchaseOption.FIVE_CREDITS:
			return "$5";
		case CreditPurchaseOption.TEN_CREDITS:
			return "$10";
		case CreditPurchaseOption.TWENTY_CREDITS:
			return "$20";
		case CreditPurchaseOption.FIFTY_CREDITS:
			return "$50";
		default:
			return "";
		}
	}
}
